import Icon from '@material-ui/icons/BugReport';
import React from 'react';
import { CreateButton } from '../../../../buttons';
import { ReferenceInput } from '../../../../inputs';

export default {
  Icon,
  menuItems: [

  ],
  dialogs: {
    create: props => (
      <CreateButton
        fixedValue={{ learning_path_level_id: props.parentResource.id }}
        {...props}
      >
        <ReferenceInput
          filter={{learning_path_id: props.parentResource.parentResource.id}}
          source="skill_level_id"
          required
        />
      </CreateButton>
    ),
  },
  routes: {
  },
  components: {
  },
  resources: {
  },
};
